/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownInstitutionType } from '../models/db_DropdownInstitutionType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InstitutionTypes {
    /**
     * Get a list of institution types
     * @returns db_DropdownInstitutionType OK
     * @throws ApiError
     */
    public static listInstitutionTypes(): CancelablePromise<Array<db_DropdownInstitutionType>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/institution-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
